module.exports = __webpack_public_path__ + "img/time_watch.5cec112b.svg";